package diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme

import androidx.compose.runtime.Immutable
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/**
 * Elevation tokens (docs/DESIGN_SYSTEM.md). Access via `AppTheme.elevation`.
 * level0 background · level1 cards/surfaces · level2 floating (search, bottom nav, FAB).
 */
@Immutable
data class AppElevation(
    val level0: Dp = 0.dp,
    val level1: Dp = 2.dp,
    val level2: Dp = 8.dp,
)

val appElevation: AppElevation = AppElevation()
